export default __webpack_public_path__ + "static/media/1516 utensils side.38d9ad26.png";